

import { FaGem } from "react-icons/fa"; // optional gem icon

const DiamondPointsCard = ({
  textcolor,
  containerColor,
  containerBorderColor,
  diamondPoints = "100",
  validityDays = "1000",
  gradientColors
}) => {
  // Build gradient string if gradientColors provided
  const buildGradientString = (colors) => {
    if (!colors || colors.length === 0) return null;
    if (colors.length === 1) return `linear-gradient(135deg, ${colors[0]}, ${colors[0]})`;
    
    const colorStops = colors.map((color, index) => {
      const percentage = (index / (colors.length - 1)) * 100;
      return `${color} ${percentage}%`;
    }).join(", ");
    
    return `linear-gradient(135deg, ${colorStops})`;
  };

  const backgroundStyle = gradientColors && gradientColors.length > 0
    ? { background: buildGradientString(gradientColors) }
    : { background: containerColor || "transparent" };

  return (
    <div style={{ padding: "0 10px", marginBottom: "8px", marginTop: "10px" }}>
      <div
        style={{
          borderRadius: "20px",
          padding: "8px",
          display: "flex",
          alignItems: "center",
          ...backgroundStyle,
          border: `1px solid ${containerBorderColor || "rgba(255, 255, 255, 0.4)"}`,
          opacity: 0.9,
        }}
      >
        {/* Diamond Icon */}
        <div style={{ marginRight: "12px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <FaGem size={24} color="white" />
        </div>

        {/* Right Side - Column */}
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          {/* Diamond Points Row */}
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <div
              style={{
                color: textcolor,
                fontSize: "12px",
                fontWeight: "400",
              }}
            >
              Diamond Points:
            </div>
            <div
              style={{
                color: textcolor,
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              {diamondPoints}
            </div>
          </div>

          {/* Validity Row */}
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <div
              style={{
                color: textcolor,
                fontSize: "12px",
                fontWeight: "400",
              }}
            >
              Points Validity:
            </div>
            <div
              style={{
                color: textcolor,
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              {validityDays} days
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiamondPointsCard;
